<section class="header">

<h1>A Haunted Story</h1>

<img src="https://res.cloudinary.com/dadqp2oia/image/upload/v1629672279/Music%20Website/Logos/EB-G-InitialLogoCutout_sga7eb.png" alt="Elyza's full logo">

</section>